import request from "../utils/request.js"

// 获取主体类型列表
export function getSubjectType() {
    return request({
        url: "/directories/getSubjectType",
        method: "get"
    })
}
// 获取手机验证码
export function sendPhoneCode(params) {
    return request({
        url: "/directories/sendCode/" + params,
        method: "get"
    })
}
// 获取七牛token
export function getQiNiuToken() {
    return request({
        url: "/resources/getToken",
        method: "get"
    })
}
// 新增主体
export function addDirectories(params) {
    return request({
        url: "/directories/subjectDeclaration",
        method: "post",
        data: params,
    })
}
// 新增小农户
export function addSmallFarmersUserApi(params) {
    return request({
        url: "/directories/addSmallFarmersUser",
        method: "post",
        data: params,
    })
}
// 新增主体
export function getList(params) {
    return request({
        url: "/directories/list",
        method: "post",
        data: params,
    })
}
// 获取主体详情
export function getDetail(params) {
    return request({
        url: "/directories/detail/" + params,
        method: "get"
    })
}
// 重置密码
export function forgetPasswordApi(params) {
    return request({
        url: "/directories/forgetPassword",
        method: "post",
        data: params,
    })
}
// 上传图片
export function uploadImageApi(params) {
    return request({
        url: "/attachment/upload",
        method: "post",
        data: params,
    })
}
// 上传签名
export function uploadSignatureApi(params) {
    return request({
        url: "/attachment/uploadSignature",
        method: "post",
        data: params,
    })
}

